import axios from "axios";
import { API_URL } from "App";

const api = axios.create();

export const fetchMissionStatement = async () => {
  const response = await api.get(`${API_URL}/statement`);
  return response;
};

export const fetchMembers = async () => {
  const response = await api.get(`${API_URL}/members`);
  return response;
};
